import { useMutation, gql, MutationHookOptions } from "@apollo/client";

export type DeleteGroupInput = {
  id: string;
};

export const DELETE_GROUP = gql`
  mutation deleteGroup($input: DeleteGroupInput!) {
    deleteGroup(input: $input) {
      id
    }
  }
`;

export default (options?: MutationHookOptions<any, Record<string, any>>) => {
  return useMutation(DELETE_GROUP, options);
};
